import { LayoutDashboard, Users, Tags, BarChart3, Receipt, ShieldCheck, Plug, Radio, Activity, Landmark, Eye, KeySquare } from "lucide-react";
import { StudioLayout } from "@/components/StudioLayout";

const NAV = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/creators", label: "Creators", icon: Users },
  { to: "/admin/live", label: "Live", icon: Radio },
  { to: "/admin/activity", label: "Activity", icon: Activity },
  { to: "/admin/owner-review", label: "Owner Review", icon: Eye },
  { to: "/admin/demo-access", label: "Demo Access", icon: KeySquare },
  { to: "/admin/pricing", label: "Pricing", icon: Tags },
  { to: "/admin/finance", label: "Finance", icon: Landmark },
  { to: "/admin/revenue", label: "Revenue", icon: BarChart3 },
  { to: "/admin/transactions", label: "Transactions", icon: Receipt },
  { to: "/admin/provider", label: "Provider", icon: ShieldCheck },
  { to: "/admin/integrations", label: "Integrations", icon: Plug },
];

export function AdminLayout() {
  return <StudioLayout nav={NAV} label="Super Admin" testPrefix="admin" />;
}
